
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { OrderLineModel } from './Entities.GormCrm.OrderLine';
import { Model, ModelProperty } from 'models/Model';


export class QualificationCallOverviewModel extends Model<QualificationCallOverviewModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'taskActionId', type: 'guid', languageString: 'qualificationCallOverview.property.taskActionId' },
		{ name: 'taskflowId', type: 'guid', languageString: 'qualificationCallOverview.property.taskflowId' },
		{ name: 'companyName', type: 'string', languageString: 'qualificationCallOverview.property.companyName' },
		{ name: 'totalPrice', type: 'number', languageString: 'qualificationCallOverview.property.totalPrice' },
		{ name: 'business', type: 'string', languageString: 'qualificationCallOverview.property.business' },
		{ name: 'sellerId', type: 'guid', languageString: 'qualificationCallOverview.property.sellerId' },
		{ name: 'salesTeamId', type: 'guid', languageString: 'qualificationCallOverview.property.salesTeamId' },
		{ name: 'signDate', type: 'Date', languageString: 'qualificationCallOverview.property.signDate' },
		{ name: 'products', type: 'OrderLineModel[]', languageString: 'qualificationCallOverview.property.products', isHidden: true, isArray: true, isObject: true, new: () => { return new OrderLineModel }, properties: () => { return OrderLineModel.classProperties } }
	];
	[key: string]: any;
	
	public taskActionId?: string;
	public taskflowId?: string;
	public companyName: string;
	public totalPrice: number;
	public business: string;
	public sellerId?: string;
	public salesTeamId?: string;
	public signDate?: Date;
	public products: OrderLineModel[];
    
	constructor(){
		super();
		this.taskActionId = undefined;
		this.taskflowId = undefined;
		this.companyName = '';
		this.totalPrice = 0;
		this.business = '';
		this.sellerId = undefined;
		this.salesTeamId = undefined;
		this.signDate = undefined;
		this.products = [];
		
	}
	getProperties(){
		return QualificationCallOverviewModel.classProperties;
	}
}

